import $ from 'jquery'
import { Core } from './core'

export class HashScroll {

  constructor () {
    if (Core.isAdmin()) return

    this.$document = $(document)
    this.$window = $(window)
    this.$body = $('body')

    this.$document.ready(this.handleLoadHashScroll.bind(this))
    this.$window.on('hashchange', this.handleChangeHashLocation.bind(this))
    this.$body.on('click', 'a[href^="#"]', this.handleClickLinkHashScroll.bind(this))
  }

  handleClickLinkHashScroll (e) {
    let hashLink = $(e.currentTarget).attr('href')

    if (hashLink.length === 1) return

    let $item = $(hashLink)

    if ($item.length === 0) return

    e.preventDefault()

    history.pushState({}, '', hashLink)

    Core.scrollTo($item, false)
  }

  handleChangeHashLocation (e) {
    if (window.location.hash !== '' && window.location.hash.length) {
      let $item = $(window.location.hash)

      if ($item.length) {
        Core.scrollTo($item, false)
      }
    }
  }

  handleLoadHashScroll (e) {
    let scrollToTab = [
      '.alert[role="alert"]'
    ]

    if (window.location.hash !== '' && window.location.hash.length && ! location.hash.includes( '/' )) {
      scrollToTab.push(location.hash)
    }

    let stopForeach = false

    for (let i = 0; i < scrollToTab.length; i++) {
      const $item = $(scrollToTab[i])

      if ($item.length && !stopForeach) {
        stopForeach = true
        Core.scrollTo($item, false)
        break
      }
    }
  }
}
